import styled, { css } from "styled-components";
import FlexBox from "./FlexBox";
import { DAVYS_GREY_100, DAVYS_GREY_500, SUCCESS_GREEN_800 } from "./colors";

const ToggleContainer = styled(FlexBox)`
  padding: 2px;
  width: 3rem;
  height: 1.5rem;
  cursor: pointer;
  pointer-events: auto;
  align-items: center;
  border-radius: 0.875rem;
  background-color: ${DAVYS_GREY_500};

  ${({ checked }) =>
    checked &&
    css`
      background-color: ${SUCCESS_GREEN_800};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

const Switch = styled(FlexBox)`
  height: 100%;
  aspect-ratio: 1;
  border-radius: 50%;
  transform: translateX(0);
  background-color: ${DAVYS_GREY_100};
  transition: transform 300ms ease-in-out;

  ${({ checked }) =>
    checked &&
    css`
      transform: translateX(117%);
    `}
`;

const ToggleSwitch = ({ checked, handleToggle, disabled = false }) => {
  return (
    <ToggleContainer
      checked={checked}
      disabled={disabled}
      onClick={disabled ? undefined : handleToggle}
    >
      <Switch checked={checked} />
    </ToggleContainer>
  );
};

export default ToggleSwitch;
